import { styled, Typography } from "@material-ui/core";
import { brand } from "../theme";

export const AuthPage = styled("div")({
  minHeight: "100vh",
  width: "100%",
  background: brand.amberFaint,
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
});

export const AuthFormArea = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: 440,
  alignSelf: "center",
  padding: theme.spacing(0, 3),
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
}));

export const Wrapper = styled("div")({
  width: "100%",
  paddingTop: 32,
  paddingBottom: 28,
  background: brand.amber,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

export const EmojiCircle = styled("div")({
  width: 72,
  height: 72,
  borderRadius: 20,
  background: brand.white,
  boxShadow: `0 10px 30px rgba(0,0,0,0.1), 0 0 0 1px ${brand.sep}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 38,
  marginBottom: 14,
  lineHeight: 1,
});

export const Title = styled((p) => <Typography variant="h4" {...p} />)({
  fontWeight: 800,
  fontSize: 28,
  letterSpacing: -0.6,
  color: brand.amberDark,
  lineHeight: 1.1,
  textAlign: "center",
  padding: "0 24px",
});

export const Subtitle = styled((p) => <Typography variant="subtitle1" {...p} />)({
  marginTop: 6,
  fontSize: 14,
  color: brand.textSec,
  textAlign: "center",
  padding: "0 24px",
});
